export interface Movie {
  id: string;
  title: string;
  year: number;
  region: string;
  genres: string[];
  director: string;
  cast: string[];
  duration: number;
  rating: number;
  popularity: number;
  tags: string[];
  poster: string;
  backdrop: string;
  tagline: string;
  summary: string;
  synopsis: string[];
  behind: string;
  featured: boolean;
}

export const movies: Movie[] = [
  {
    id: "yu-zhong-lai-xin",
    title: "雨中来信",
    year: 2023,
    region: "中国大陆",
    genres: ["都市爱情", "治愈"],
    director: "林知远",
    cast: ["苏未晚", "陈屿", "何轻舟"],
    duration: 118,
    rating: 8.7,
    popularity: 96,
    tags: ["雨天", "久别重逢", "书信", "慢热"],
    poster:
      "https://readdy.ai/api/search-image?query=Stylized%20romantic%20film%20poster%20illustration%20of%20a%20young%20couple%20sharing%20one%20umbrella%20on%20a%20quiet%20rainy%20city%20street%20at%20dusk%2C%20soft%20rose%20and%20ivory%20color%20palette%20with%20warm%20golden%20light%20accents%2C%20elegant%20cinematic%20composition%2C%20dreamy%20atmospheric%20mood%2C%20painterly%20textured%20background%2C%20delicate%20bokeh%20raindrops%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=mv-yuzhong-01&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20scene%20of%20a%20rainy%20old%20town%20street%20glowing%20with%20warm%20lamplight%20at%20dusk%20with%20two%20distant%20figures%20under%20an%20umbrella%2C%20soft%20rose%20and%20ivory%20tones%20with%20golden%20accents%2C%20dreamy%20atmospheric%20painterly%20illustration%2C%20reflective%20wet%20pavement%2C%20no%20text%2C%20high%20detail&width=1600&height=900&seq=mv-yuzhong-bd&orientation=landscape",
    tagline: "有些话，只有雨天适合说出口。",
    summary:
      "一封迟到七年的信，在一个连绵的雨季被打捞上岸。邮差苏未晚与旧书店主陈屿，在潮湿的街巷里重新学会靠近彼此。",
    synopsis: [
      "故事开始于南方一座常年多雨的小城。苏未晚是邮局里最不起眼的临时工，她负责投递一片即将拆迁老城区的信件。一封没有收件人地址、只写着「陈屿 收」的旧信，在雨里辗转了七年后，终于落到她手中。",
      "陈屿在巷口经营着一家濒临倒闭的旧书店，性格疏离，靠整理旧书度日。当苏未晚把那封信交给他时，他没有立刻拆开，而是先问了一句：「这雨，你淋了很久吧？」",
      "两人从一封信开始，慢慢交换各自的生活。苏未晚喜欢在工作日志上写诗，陈屿则习惯在书的扉页留下批注。雨季越拉越长，两人之间的距离却越来越短。",
      "影片没有强烈的戏剧冲突，而是用大量留白与雨声，让感情在琐碎的日常里自然生长，最终落在「原来等一个人，也是一种告白」的温柔落点上。",
    ],
    behind:
      "为了捕捉真实的雨感，剧组在南方小城实景拍摄了四十余天，几乎所有雨戏均为自然降雨，片中旧书店由一间真实的老屋改造而成。",
    featured: true,
  },
  {
    id: "hai-na-bian",
    title: "海那边",
    year: 2022,
    region: "日本",
    genres: ["文艺剧情", "青春"],
    director: "中村由纪",
    cast: ["森川遥", "石井彻", "北原夏"],
    duration: 124,
    rating: 8.4,
    popularity: 88,
    tags: ["海边", "青春", "离别", "夏天"],
    poster:
      "https://readdy.ai/api/search-image?query=Stylized%20romantic%20film%20poster%20illustration%20of%20two%20teenagers%20standing%20on%20a%20sunlit%20seaside%20pier%20looking%20toward%20the%20horizon%2C%20soft%20rose%20and%20ivory%20color%20palette%20with%20warm%20golden%20light%20accents%2C%20elegant%20cinematic%20composition%2C%20dreamy%20atmospheric%20mood%2C%20painterly%20textured%20background%2C%20gentle%20sea%20mist%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=mv-haibian-01&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20view%20of%20a%20calm%20summer%20sea%20with%20a%20long%20wooden%20pier%20at%20golden%20hour%2C%20soft%20rose%20and%20ivory%20tones%20with%20warm%20golden%20accents%2C%20dreamy%20atmospheric%20painterly%20illustration%2C%20minimal%20quiet%20mood%2C%20no%20text%2C%20high%20detail&width=1600&height=900&seq=mv-haibian-bd&orientation=landscape",
    tagline: "他把整个夏天，都留给了海边。",
    summary:
      "高考结束的那个夏天，森川遥在海边小镇遇见了即将离开的转学生石井彻。一段注定要告别的相遇，却成了彼此一生最长的夏天。",
    synopsis: [
      "森川遥是海边小镇唯一的补习老师，她的生活被试卷和潮汐填满。转学生石井彻的出现，打破了这座小镇惯有的沉默。",
      "石井彻只在镇上停留一个夏天，因为他要在秋天离开去往远方。两人心照不宣地不谈未来，只认真地过好每一个黄昏。",
      "他们在防波堤上看焰火，在旧站台等一班永远不会来的末班车。海风把未说出口的话吹散，也把感情吹得更近。",
      "影片以克制的镜头语言讲述离别，结尾处森川遥独自站在海边的长镜头，被观众称为「一整年最安静的眼泪」。",
    ],
    behind:
      "本片全程在真实渔港小镇取景，群演多为当地居民。导演坚持使用自然光拍摄，绝大多数海边镜头都在日出前半小时完成。",
    featured: false,
  },
  {
    id: "bali-de-zuihou-yizhiwu",
    title: "巴黎的最后一支舞",
    year: 2019,
    region: "法国",
    genres: ["浪漫剧情", "古典"],
    director: "Élodie Marchand",
    cast: ["Camille Roux", "Julien Blanc", "Sophie Mercier"],
    duration: 132,
    rating: 8.9,
    popularity: 93,
    tags: ["巴黎", "舞蹈", "旧时光", "重逢"],
    poster:
      "https://readdy.ai/api/search-image?query=Stylized%20romantic%20film%20poster%20illustration%20of%20an%20elegant%20couple%20waltzing%20in%20a%20grand%20vintage%20parisian%20ballroom%20at%20night%2C%20soft%20rose%20and%20ivory%20color%20palette%20with%20warm%20golden%20chandelier%20accents%2C%20elegant%20cinematic%20composition%2C%20dreamy%20atmospheric%20mood%2C%20painterly%20textured%20background%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=mv-bali-01&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20scene%20of%20a%20grand%20vintage%20parisian%20ballroom%20glowing%20with%20warm%20golden%20chandeliers%20at%20night%2C%20soft%20rose%20and%20ivory%20tones%20with%20golden%20accents%2C%20dreamy%20atmospheric%20painterly%20illustration%2C%20romantic%20empty%20dance%20floor%20reflection%2C%20no%20text%2C%20high%20detail&width=1600&height=900&seq=mv-bali-bd&orientation=landscape",
    tagline: "有些舞跳到最后，才知道是告别。",
    summary:
      "一位老去的芭蕾名伶与年轻的钢琴调音师，在巴黎一间即将关闭的舞厅里，共舞了人生最后一支华尔兹。",
    synopsis: [
      "Camille 曾是巴黎歌剧院最耀眼的舞者，如今独自守着郊外一间老舞厅。年轻的调音师 Julien 被雇来维护那架年迈的钢琴，两人的相遇始于一段跑调的旋律。",
      "Camille 起初对这个年轻人充满戒备，却在他的琴声里重新想起自己跳舞的理由。舞厅即将被改建成商场，她决定用最后一场舞会与过去告别。",
      "排练的日子里，年龄与经历的巨大差异并没有成为障碍，反而让两人看见了彼此最柔软的部分。",
      "全片以光影与音乐推进情感，最后一支华尔兹长达九分钟，被认为是近十年最优雅的爱情长镜头之一。",
    ],
    behind:
      "影片使用真实的百年舞厅拍摄，钢琴与舞鞋均为道具师手工复刻。女主角为完成舞蹈段落接受了半年的芭蕾训练。",
    featured: true,
  },
  {
    id: "dongri-huaibiao",
    title: "冬日怀表",
    year: 2020,
    region: "中国大陆",
    genres: ["奇幻爱情", "悬疑"],
    director: "顾云舟",
    cast: ["周亦宁", "许墨白", "陆沉"],
    duration: 115,
    rating: 8.2,
    popularity: 85,
    tags: ["时间循环", "怀表", "救赎", "雪"],
    poster:
      "https://readdy.ai/api/search-image?query=Stylized%20romantic%20fantasy%20film%20poster%20illustration%20of%20a%20lone%20figure%20holding%20a%20glowing%20vintage%20pocket%20watch%20in%20a%20snowy%20old%20street%20at%20night%2C%20soft%20rose%20and%20ivory%20color%20palette%20with%20warm%20golden%20glow%20accents%2C%20elegant%20cinematic%20composition%2C%20dreamy%20atmospheric%20mood%2C%20painterly%20textured%20background%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=mv-huaiibiao-01&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20scene%20of%20a%20snowy%20old%20european%20style%20street%20at%20night%20with%20warm%20window%20lanterns%20glowing%2C%20soft%20rose%20and%20ivory%20tones%20with%20golden%20accents%2C%20dreamy%20atmospheric%20painterly%20illustration%2C%20quiet%20mysterious%20mood%2C%20no%20text%2C%20high%20detail&width=1600&height=900&seq=mv-huaiibiao-bd&orientation=landscape",
    tagline: "如果时间可以倒回，你还愿意再爱一次吗？",
    summary:
      "一块停在冬夜的旧怀表，让摄影师周亦宁一次次回到事故发生的那一天。她能改变时间，却无法改变心动。",
    synopsis: [
      "摄影师周亦宁在整理祖父遗物时，发现了一块停摆的怀表。当她按下表冠，时间便会回到同一天的清晨。",
      "最初她只想阻止那场带走挚爱的意外，可每一次改变都会带来新的代价。她逐渐意识到，真正困住自己的不是时间，而是没能说出口的那句喜欢。",
      "在无数次循环中，她重新认识了这个沉默寡言的人——那些被忽略的善意与笨拙的关心。",
      "影片用冷峻的雪景与细密的时间线，讲述了一个关于接受与释怀的爱情故事，结局克制而温柔。",
    ],
    behind:
      "怀表道具由钟表匠定制，具备真实走时功能。雪景拍摄时恰逢二十年不遇的大雪，多数镜头为实景捕捉。",
    featured: false,
  },
  {
    id: "chang-ye",
    title: "长夜将尽",
    year: 2018,
    region: "韩国",
    genres: ["现实主义", "剧情"],
    director: "박진우",
    cast: ["한서연", "이도현", "김민재"],
    duration: 128,
    rating: 8.6,
    popularity: 82,
    tags: ["现实题材", "深夜", "出租车", "救赎"],
    poster:
      "https://readdy.ai/api/search-image?query=Stylized%20romantic%20drama%20film%20poster%20illustration%20of%20two%20people%20talking%20inside%20a%20warmly%20lit%20night%20taxi%20in%20a%20rainy%20city%2C%20soft%20rose%20and%20ivory%20color%20palette%20with%20warm%20golden%20window%20accents%2C%20elegant%20cinematic%20composition%2C%20melancholic%20atmospheric%20mood%2C%20painterly%20textured%20background%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=mv-changye-01&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20view%20of%20an%20empty%20rainy%20city%20street%20at%20deep%20night%20with%20warm%20streetlight%20reflections%2C%20soft%20rose%20and%20ivory%20tones%20with%20golden%20accents%2C%20dreamy%20melancholic%20painterly%20illustration%2C%20longing%20quiet%20mood%2C%20no%20text%2C%20high%20detail&width=1600&height=900&seq=mv-changye-bd&orientation=landscape",
    tagline: "漫漫长夜里，总有人愿意陪你开到天亮。",
    summary:
      "一名夜班出租车司机与一位每晚去往同一地点的乘客，在一段段深夜行程里，慢慢拼出各自的伤口与温柔。",
    synopsis: [
      "司机在一场意外后失去了开口的勇气，只想沉默地开完每一个夜班。而那位乘客，每晚都去往同一家医院的方向。",
      "他们很少交谈，却在车厢这个小小的空间里，慢慢交出了各自最深的秘密。城市的霓虹在窗外流过，像一段段没说出口的往事。",
      "当乘客不再出现，司机才发现，自己早已把对方当成了漫漫长夜里唯一的方向。",
      "影片以克制的现实笔触描绘都市孤独，被评论界称为「写给深夜的温柔情书」。",
    ],
    behind:
      "大部分车内戏份在真实行驶的车上完成，采用自然路灯照明。为呈现城市夜态，剧组连续拍摄了六十个深夜。",
    featured: false,
  },
  {
    id: "cheng-nan-hua-kai",
    title: "城南花开",
    year: 2021,
    region: "中国大陆",
    genres: ["青春校园", "甜宠"],
    director: "夏安然",
    cast: ["沈知夏", "顾清让", "白沐"],
    duration: 108,
    rating: 8.0,
    popularity: 90,
    tags: ["校园", "暗恋", "同桌", "夏天"],
    poster:
      "https://readdy.ai/api/search-image?query=Stylized%20romantic%20teen%20film%20poster%20illustration%20of%20two%20high%20school%20deskmates%20under%20a%20blooming%20tree%20in%20warm%20afternoon%20light%2C%20soft%20rose%20and%20ivory%20color%20palette%20with%20warm%20golden%20sun%20accents%2C%20elegant%20cinematic%20composition%2C%20dreamy%20nostalgic%20mood%2C%20painterly%20textured%20background%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=mv-chengnan-01&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20scene%20of%20a%20sunlit%20school%20playground%20with%20a%20large%20blooming%20tree%20in%20golden%20afternoon%20light%2C%20soft%20rose%20and%20ivory%20tones%20with%20warm%20golden%20accents%2C%20dreamy%20nostalgic%20painterly%20illustration%2C%20no%20text%2C%20high%20detail&width=1600&height=900&seq=mv-chengnan-bd&orientation=landscape",
    tagline: "我从没说过喜欢你，但每一页笔记都写满了你。",
    summary:
      "高二那年，转学生沈知夏坐到了寡言学霸顾清让的旁边。一整年的同桌时光，藏着一场谁都没有先说出口的暗恋。",
    synopsis: [
      "沈知夏因为父母工作调动转学到城南中学，被安排坐在年级第一顾清让旁边。一个爱说话，一个几乎不开口，性格的反差让两人一开始摩擦不断。",
      "顾清让有轻微的口吃，习惯用纸条与人交流；沈知夏则用每天一本的漫画，慢慢敲开了他的沉默。",
      "他们一起准备竞赛、一起逃过一次合唱排练、一起在放学后分享一副耳机。青春里最普通的日常，成了最珍贵的记忆。",
      "影片用明亮的色调和细腻的细节，还原了每个人心中都曾有过的那个「同桌的你」。",
    ],
    behind:
      "校园取景地为一所仍在运营的高中，拍摄安排在暑假进行。片中出现的漫画与笔记均为演员亲手绘制。",
    featured: false,
  },
  {
    id: "manhadun-de-lan",
    title: "曼哈顿的蓝",
    year: 2017,
    region: "美国",
    genres: ["浪漫喜剧", "都市"],
    director: "Nathan Cole",
    cast: ["Emma Wells", "David Park", "Chloe Reed"],
    duration: 106,
    rating: 7.9,
    popularity: 78,
    tags: ["纽约", "喜剧", "误会", "都会"],
    poster:
      "https://readdy.ai/api/search-image?query=Stylized%20romantic%20comedy%20film%20poster%20illustration%20of%20a%20cheerful%20couple%20standing%20on%20a%20new%20york%20rooftop%20above%20city%20lights%20at%20blue%20hour%2C%20soft%20rose%20and%20ivory%20color%20palette%20with%20warm%20golden%20window%20accents%2C%20elegant%20cinematic%20composition%2C%20playful%20atmospheric%20mood%2C%20painterly%20textured%20background%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=mv-manhadun-01&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20view%20of%20a%20new%20york%20city%20skyline%20rooftop%20at%20blue%20hour%20with%20warm%20glowing%20windows%2C%20soft%20rose%20and%20ivory%20tones%20with%20golden%20accents%2C%20dreamy%20romantic%20painterly%20illustration%2C%20lively%20urban%20mood%2C%20no%20text%2C%20high%20detail&width=1600&height=900&seq=mv-manhadun-bd&orientation=landscape",
    tagline: "一场误会，让两个陌生人整个冬天都黏在一起。",
    summary:
      "一间被误租的公寓，让两个素不相识的纽约客被迫同住。吵吵闹闹的同居日常里，爱情悄悄换了地址。",
    synopsis: [
      "插画师 Emma 好不容易找到一间价格合适的公寓，却发现房门从未真正属于自己——一位名叫 David 的厨师也拿着同一把钥匙。",
      "中介早已跑路，谁都不愿搬走。两人只好立下「井水不犯河水」的同居守则，却在共享厨房与吵架摔门中慢慢越界。",
      "Emma 的画稿里开始出现陌生的身影，David 的菜单上也多了一道只有某人爱吃的不辣菜。",
      "影片以轻快的节奏与密集的笑点，讲述都市里最常见的浪漫：有时爱情只是住错了门牌号。",
    ],
    behind:
      "公寓场景为布景搭建，还原了纽约老式公寓的窄长格局。两位主演在开拍前于同住公寓共处两周以磨合默契。",
    featured: false,
  },
  {
    id: "shiguang-lvren",
    title: "时光旅人",
    year: 2020,
    region: "英国",
    genres: ["奇幻爱情", "文艺"],
    director: "Oliver Grant",
    cast: ["Eleanor Shaw", "Tom Bennett", "Grace Hall"],
    duration: 119,
    rating: 8.3,
    popularity: 80,
    tags: ["英伦", "时空", "旧相机", "宿命"],
    poster:
      "https://readdy.ai/api/search-image?query=Stylized%20romantic%20fantasy%20film%20poster%20illustration%20of%20a%20woman%20holding%20an%20old%20film%20camera%20in%20a%20misty%20english%20countryside%20field%20at%20dawn%2C%20soft%20rose%20and%20ivory%20color%20palette%20with%20warm%20golden%20light%20accents%2C%20elegant%20cinematic%20composition%2C%20dreamy%20atmospheric%20mood%2C%20painterly%20textured%20background%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=mv-shiguang-01&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20view%20of%20a%20misty%20english%20countryside%20field%20with%20an%20old%20stone%20cottage%20at%20dawn%2C%20soft%20rose%20and%20ivory%20tones%20with%20warm%20golden%20accents%2C%20dreamy%20atmospheric%20painterly%20illustration%2C%20quiet%20timeless%20mood%2C%20no%20text%2C%20high%20detail&width=1600&height=900&seq=mv-shiguang-bd&orientation=landscape",
    tagline: "她拍下的每一张照片，都是一封寄往未来的信。",
    summary:
      "一台能定格时间的老相机，让摄影师 Eleanor 在胶片里反复遇见同一个陌生男子。她越是想看清他，就越接近一场注定的重逢。",
    synopsis: [
      "Eleanor 在祖父的阁楼里翻出一台老式胶片相机，奇怪的是，每次冲洗出来的照片里，总会多出一个她从未见过的人。",
      "她开始循着照片里的线索寻找这个男人，却发现对方也一直在寻找她——只是隔着不同的时间。",
      "两人通过照片与信件建立起一种奇特的联系，用最慢的方式，谈了一场跨越时间的恋爱。",
      "影片以近乎诗意的镜头语言探讨时间与缘分，结尾处一帧定格照片让无数观众泪目。",
    ],
    behind:
      "片中所有照片均由剧组摄影指导实拍冲印，未使用数字后期合成。乡村场景取景于英格兰北部真实农庄。",
    featured: false,
  },
  {
    id: "ming-yue-zhao-gui-tu",
    title: "明月照归途",
    year: 2019,
    region: "中国香港",
    genres: ["古装爱情", "剧情"],
    director: "叶澄",
    cast: ["沈梨", "裴砚", "温绫"],
    duration: 141,
    rating: 8.8,
    popularity: 89,
    tags: ["古装", "江湖", "等待", "明月"],
    poster:
      "https://readdy.ai/api/search-image?query=Stylized%20elegant%20ancient%20chinese%20romance%20film%20poster%20illustration%20of%20a%20figure%20in%20flowing%20robes%20standing%20on%20a%20moonlit%20ancient%20bridge%2C%20soft%20rose%20and%20ivory%20color%20palette%20with%20warm%20golden%20lantern%20accents%2C%20elegant%20cinematic%20composition%2C%20dreamy%20atmospheric%20mood%2C%20painterly%20textured%20ink%20background%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=mv-mingyue-01&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20scene%20of%20a%20moonlit%20ancient%20chinese%20water%20town%20with%20glowing%20lanterns%20along%20the%20river%2C%20soft%20rose%20and%20ivory%20tones%20with%20warm%20golden%20accents%2C%20dreamy%20atmospheric%20painterly%20ink%20illustration%2C%20serene%20poetic%20mood%2C%20no%20text%2C%20high%20detail&width=1600&height=900&seq=mv-mingyue-bd&orientation=landscape",
    tagline: "明月千里，只为照你归来。",
    summary:
      "江湖女侠沈梨为赴一场十年之约，踏遍山河。而她要等的人，是否还记得当年桥头的那轮明月。",
    synopsis: [
      "十年前的中秋，沈梨与少年裴砚在江南石桥立下约定：十年后，无论身在何处，都要回到这里看一次明月。",
      "十年间，沈梨成了江湖上人人敬畏的剑客，裴砚却杳无音讯。她一边行走江湖，一边四处打听他的下落。",
      "归途之上，她遇见了形形色色的人，也一次次在别人的故事里，看见自己执着等待的影子。",
      "影片以东方美学与克制的叙事，讲述一个关于承诺与时间的故事，明月成为了贯穿全片的深情意象。",
    ],
    behind:
      "剧组在江南水乡实地取景，服装纹样参考宋代文物设计。所有夜景均为夜间实拍，力求还原古时月色。",
    featured: true,
  },
  {
    id: "kafei-yu-yu",
    title: "咖啡与雨",
    year: 2022,
    region: "中国台湾",
    genres: ["小清新", "都市爱情"],
    director: "许安",
    cast: ["程以宁", "梁书言", "方晴"],
    duration: 104,
    rating: 8.1,
    popularity: 84,
    tags: ["咖啡馆", "手冲", "台北", "慢生活"],
    poster:
      "https://readdy.ai/api/search-image?query=Stylized%20cozy%20romantic%20film%20poster%20illustration%20of%20a%20barista%20pouring%20coffee%20in%20a%20small%20rainy%20taipei%20cafe%20with%20warm%20lights%2C%20soft%20rose%20and%20ivory%20color%20palette%20with%20warm%20golden%20accents%2C%20elegant%20cinematic%20composition%2C%20dreamy%20atmospheric%20mood%2C%20painterly%20textured%20background%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=mv-kafei-01&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20scene%20of%20a%20cozy%20small%20cafe%20interior%20with%20warm%20hanging%20lights%20and%20rain%20streaked%20windows%2C%20soft%20rose%20and%20ivory%20tones%20with%20warm%20golden%20accents%2C%20dreamy%20atmospheric%20painterly%20illustration%2C%20quiet%20warm%20mood%2C%20no%20text%2C%20high%20detail&width=1600&height=900&seq=mv-kafei-bd&orientation=landscape",
    tagline: "一杯手冲的温度，刚好够等一个人。",
    summary:
      "台北巷弄里的一间小咖啡馆，店主程以宁习惯为雨天留一个位置。某天，这个位置真的等来了它的人。",
    synopsis: [
      "程以宁的咖啡馆开在一条安静的巷子里，生意清淡，却总有几只流浪猫和一群熟客。她说，雨天来的客人，咖啡可以续杯。",
      "一个雨天，抱着画板的梁书言推门而入，从此成了这间店最规律的客人。他只点同一款豆子，坐在同一个角落。",
      "两人从豆子的产地聊到各自的生活，程以宁慢慢发现，这个沉默的画家，其实一直在画她。",
      "影片节奏舒缓，画面温暖，是一封写给慢生活与偶然相遇的小情书。",
    ],
    behind:
      "咖啡馆场景为实景改造，片中出现的手冲手法由专业咖啡师指导。雨天镜头等待了整整三周才拍齐。",
    featured: false,
  },
  {
    id: "yinhe-jintou-de-ni",
    title: "银河尽头的你",
    year: 2024,
    region: "中国大陆",
    genres: ["科幻爱情", "剧情"],
    director: "江屿",
    cast: ["沈栖", "顾星野", "叶知秋"],
    duration: 136,
    rating: 8.5,
    popularity: 95,
    tags: ["科幻", "星际", "信号", "等待"],
    poster:
      "https://readdy.ai/api/search-image?query=Stylized%20romantic%20sci%20fi%20film%20poster%20illustration%20of%20a%20figure%20gazing%20at%20a%20vast%20starfield%20through%20a%20space%20station%20window%2C%20soft%20rose%20and%20ivory%20color%20palette%20with%20warm%20golden%20star%20accents%2C%20elegant%20cinematic%20composition%2C%20dreamy%20atmospheric%20mood%2C%20painterly%20textured%20cosmic%20background%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=mv-yinhe-01&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20view%20of%20a%20vast%20romantic%20starfield%20with%20a%20distant%20glowing%20space%20station%2C%20soft%20rose%20and%20ivory%20tones%20with%20warm%20golden%20accents%2C%20dreamy%20atmospheric%20painterly%20illustration%2C%20grand%20tender%20cosmic%20mood%2C%20no%20text%2C%20high%20detail&width=1600&height=900&seq=mv-yinhe-bd&orientation=landscape",
    tagline: "就算隔着整个银河，我也要听清你说的那句喜欢。",
    summary:
      "深空信号员沈栖日复一日监听宇宙中的信号，直到某天，她收到了一段跨越光年、带着熟悉声音的告白。",
    synopsis: [
      "沈栖在一座偏远的深空监听站独自工作，日常是与冰冷的设备和无尽的噪音为伴。她最大爱好，是把无人应答的信号整理成日记。",
      "某天，一串规律又温柔的载波出现了，破译后竟是一段人类语言的告白，声音属于一位已经在多年前失联的宇航员。",
      "信号穿越光年的时间差，意味着当沈栖听到时，说话的人也许早已不在。她依然决定回应，用最原始的方式，向宇宙喊出那句话。",
      "影片以硬核的科幻设定包裹一段极致浪漫的等待，探讨距离、时间与「被听见」的意义。",
    ],
    behind:
      "监听站场景为实景搭建，声效团队采集了真实射电望远镜的底噪。主演为呈现孤独感，提前进入封闭环境体验生活。",
    featured: true,
  },
  {
    id: "qiuri-siyu",
    title: "秋日私语",
    year: 2016,
    region: "日本",
    genres: ["文艺剧情", "治愈"],
    director: "佐藤直子",
    cast: ["田中美咲", "小林航", "藤井樱"],
    duration: 112,
    rating: 8.4,
    popularity: 76,
    tags: ["秋天", "庭院", "书信", "老去"],
    poster:
      "https://readdy.ai/api/search-image?query=Stylized%20gentle%20romantic%20film%20poster%20illustration%20of%20an%20elderly%20woman%20tending%20a%20small%20autumn%20garden%20with%20falling%20maple%20leaves%2C%20soft%20rose%20and%20ivory%20color%20palette%20with%20warm%20golden%20autumn%20accents%2C%20elegant%20cinematic%20composition%2C%20dreamy%20atmospheric%20mood%2C%20painterly%20textured%20background%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=mv-qiuri-01&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20view%20of%20a%20quiet%20autumn%20garden%20with%20falling%20golden%20leaves%20and%20an%20old%20wooden%20house%2C%20soft%20rose%20and%20ivory%20tones%20with%20warm%20golden%20accents%2C%20dreamy%20atmospheric%20painterly%20illustration%2C%20serene%20nostalgic%20mood%2C%20no%20text%2C%20high%20detail&width=1600&height=900&seq=mv-qiuri-bd&orientation=landscape",
    tagline: "爱了一辈子，也不过是记得你爱吃什么。",
    summary:
      "一位独居老人守着丈夫留下的庭院。当年轻租客搬进隔壁，一段被尘埃覆盖的往事，随着落叶重新散开。",
    synopsis: [
      "田中美咲在丈夫离世后，独自打理着两人共同种下的庭院。她习惯每天写一封不会被寄出的信。",
      "年轻的小林航搬进隔壁的旧屋，起初只想安静地生活，却被院子里传出的书信朗读声吸引。",
      "两人从一株快枯死的枫树开始交谈，美咲慢慢讲起自己的故事，而小林也在这段相处里，重新理解了「陪伴」的重量。",
      "影片以四季流转的庭院为舞台，讲述爱情如何在时间的冲刷下，变成细水长流的记得。",
    ],
    behind:
      "庭院取景于京都近郊的老宅，片中出现的植物均按季节真实种植。导演坚持用胶片拍摄以呈现秋天的层次。",
    featured: false,
  },
];

export default movies;